import { Component, OnInit } from "@angular/core";
import { DataService } from "src/app/data.service";
import { ActivatedRoute, Router } from "@angular/router";
@Component({
  selector: "app-dashboardlist",
  templateUrl: "./dashboardlist.component.html",
  styleUrls: ["./dashboardlist.component.scss"],
})
export class DashboardlistComponent implements OnInit {
  displayedColumns: string[] = [
    "labelname",
    "folder",
    "createdby",
    "createddate",
    "modifiedby",
    "modifieddate",
    "actions",

  ];
  dataSource: any[] = [];

  isLoading = false;
  isError = false;
  errorMessage = "";
  reportId = "";
  mode = "";
  dashboards = [];
  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private router: Router
  ) {}
  ngOnInit() {
    this.getDashboard();
  }

  new() {
    this.router.navigateByUrl("/home/dashboard/new");
    // window.location.reload()
  }
  edit(id: any, name: any) {
    console.log(id);
    console.log(name);
    this.router.navigateByUrl("home/dashboard/edit/" + name + "/" + id);
  }

  getDashboard() {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    // const domain = localStorage.getItem("domain");
    // const subdomain = localStorage.getItem("subdomain");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );
    this.isLoading = true;
    this.dataService.getDashboard(organizationid, domain, subdomain).subscribe(
      (res) => {
        // alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          // alert("Are you sure?")
          // this.router.navigate(['home/globalaction'])
          // window.location.reload();
          this.dashboards = res.data.dashboard;
          if (this.dashboards != null) {
            this.dataSource = this.dashboards.map((dashboard) => ({
              id: dashboard.id,
              labelname: dashboard.name,
              name: dashboard.name,
              folder: dashboard.folderid,
              createdby: dashboard.createdby,
              createddate: dashboard.createddate,
              modifiedby: dashboard.modifiedby,
              modifieddate: dashboard.modifieddate,
              // actions: dashboard.name,
            }));
          }
          this.isLoading = false;
        } else {
          console.log("error in getting data");
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
  cancel(){
    this.router.navigateByUrl("/home");

  }

  delete(id: number) {
    // alert(id);
    const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );
    const confirmDelete = window.confirm("Are you sure you want to delete?");

    if (!confirmDelete) {
      return;
    }

    this.isLoading = true;
    this.dataService
      .deleteDashboard(organizationid, domain, subdomain, id)
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            // alert("Are you sure?")
            window.location.reload();

            this.isLoading = false;
          } else {
            console.log("error while deleting");
            this.isLoading = false;
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
        }
      );
  }
}
